import { AnalyticsGate } from './AnalyticsGate';
import { ConsentBanner } from './ConsentBanner';
import { ConsentPreferencesDialog } from './ConsentPreferencesDialog';

export function ConsentManager() {
  return (
    <>
      <AnalyticsGate />
      <ConsentPreferencesDialog />
      <ConsentBanner />
    </>
  );
}


